import Swiper from 'swiper/bundle';

class class_swiper {
    constructor($target, $props, $isEditor = true, $cbfn = null) {
        this.settings = $props;     //object
        this.isEditor = $isEditor;  //boolean
        this.cbfn = $cbfn;          //function
        this.scopeId = $props.id;  //string

        this.isActive = false;
        
        this.target = $target.querySelector(".slidercarousel-swiper");
        this.paginationEl = $target.querySelector(".swiper-pagination");
        this.swiper;
        this.time = $isEditor ? 100 : 0;

        if(!$isEditor) this.settings.carouselEditorPreview = true;
        this.init();
        //console.log('$props',$props);
        //console.log(this.paginationEl)
        if(this.cbfn) this.cbfn(this);
    }
    init(){
        this.active();
        

        //console.log('t',this.target)

        if (this.target && this.settings.carouselEditorPreview) {

            //this.settings = JSON.parse(this.target.getAttribute('data-settings'));

            const ide = this.settings.ide;
            

            let obPagination = false;
            if(this.settings.usePagination){
                obPagination = {
                    enabled: this.settings.usePagination,
                    el: '.swiper-pagination',
                    clickable: true,
                    type: this.settings.paginationType,
                    dynamicBullets: this.settings.paginationDynamicBullets
                }
            }
            let obNavigation = false;
            if(this.settings.useNavigation){
                obNavigation = {
                    enabled: this.settings.useNavigation,
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
            let obScrollbar = false;
            if(this.settings.useScrollbar){
                obScrollbar = {
                    enabled: this.settings.useScrollbar,
                    el: '.swiper-scrollbar'
                }
            }
            let obAutoplay = false;
            if(this.settings.useAutoplay){
                obAutoplay = {
                    delay: this.settings.autoplaySpeed ? this.settings.autoplaySpeed * 1000 : 5000
                }
            }
            
            // init Swiper: -------------------------------------------------
            console.log(this.settings.postPerView)
            setTimeout(()=>{
                this.swiper = new Swiper(this.target,{
                    loop: this.settings.useLoop,
                    slidesPerView: this.settings.postPerView.mobile,
                    spaceBetween: this.settings.spaceBetween,
                    // Responsive breakpoints
                    breakpoints: {
                        // when window width is >= 1023px
                        600: {
                            slidesPerView: this.settings.postPerView.tablet,
                        },
                        // when window width is >= 1023px
                        1023: {
                            slidesPerView: this.settings.postPerView.desktop,
                        }
                    },
                    breakpointsBase: "window",
                    // If we need pagination
                    pagination: obPagination,
    
                    // Navigation arrows
                    navigation: obNavigation,
    
                    // Scrollbar arrows
                    scrollbar: obScrollbar,
                    autoHeight: this.settings.useAutoHeight,
                    mouseWheel: this.settings.useMousewheel,
                    autoplay: obAutoplay,
                    centeredSlides: this.settings.centerSlides,
                    centerInsufficientSlides: this.settings.centerSlides,
                    effect: this.settings.effect
                });
            },this.time)
            
            
            
            // --------------------------------------------------------------
        }
    }

    remove(){
        if(this.swiper) this.swiper.destroy()
    }
    rigenerate(){
        this.remove();
        this.init();
    }
    active(){
       //
       this.isActive = true;
       //console.log('sliderCarouser-settings',this.settings)
    }
    deactive(){
        //
        this.isActive = false;

    }
    
    // CHANGES
    elementChange(propertyName, settings) {
    
        this.settings = settings;

        if(this.settings.carouselEditorPreview){
            this.rigenerate();
            
            if ('postPerView' === propertyName) {
                //this.swiper.params.slidesPerView = this.settings.postPerView.desktop; 
            }
            if ('usePagination' === propertyName) {
                if(this.settings.usePagination){
                    
                }else{
                    
                }
            }
            if ('useNavigation' === propertyName) {
                if(this.settings.useNavigation){
                    
                }else{
                    
                }
            }
            if ('useScrollbar' === propertyName) {
                if(this.settings.useScrollbar){
                    
                }else{
                    
                }
            }
            console.log(this.settings.paginationDynamicBullets)
            if(this.swiper) this.swiper.update();
        }else{
            this.remove();
        }
    }
}
export default class_swiper;